import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-29/task-01";

const task: Slide = {
  titleHtml: `A duct has a cross section of 200 mm x 400 mm and is 2 m long. The airflow coming<br>through this duct is 1000 m3/h. What is the airspeed in the duct ?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
